module.exports = __webpack_public_path__ + "e2df11deb360f67ed84d94dd3c047e0c.pdf";